module.exports = __webpack_public_path__ + "img/globe-lock.05eb5c45.svg";